module.exports = __webpack_public_path__ + "img/contrology-atc@1x.64cccdc3.png";